import { Lesson } from "@jelly/lesson";
import principle01 from "./layouts/principle-01/principle";
import principle02 from "./layouts/principle-02/principle";
import principle03 from "./layouts/principle-03/principle";
import principle04 from "./layouts/principle-04/principle";
import principle05 from "./layouts/principle-05/principle";

const lesson: Lesson = {
  id: "ed79e3e9-9b10-4714-b8c1-b7dbc05b3953",
  publicId: "31",
  name: "Architectural acoustics: comparison simulation and measurement",
  difficulty: 2,
  contentTypes: { audio: true, interactive: true, video: false },
  showHeaderNavigation: false,
  body: [principle01, principle02, principle03, principle04, principle05],
};

export default lesson;
